export const EDIT = "fa fa-edit" ;
export const PERSON_ADD = "fa fa-user-plus";
export const SUBJECT_ADD = "fa fa-plus-square";

export const REMOVE = "fa fa-trash";


export const CHECK = "fa fa-check" ;
export const CANCEL = "fa fa-times" ;
export const BAN = "fa fa-ban" ;

export const COMMENT ="fa fa-comment-o";

export const DOWNLOAD ="fa fa-cloud-download";

